import { IconProps, NocIconGenerator } from '../common';

export const Sponsored = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'Sponsored',
            path: (
                <>
                    <path
                        d="M11.0753 2.82977C11.5768 2.40131 12.4323 2.39803 12.9474 2.83172L14.5236 4.18914C14.7314 4.3689 15.0036 4.51235 15.2677 4.61102C15.5323 4.70984 15.8335 4.77996 16.1105 4.77996H17.8097C18.5934 4.77996 19.2402 5.42595 19.2404 6.20965V7.90984C19.2404 8.18254 19.3111 8.48339 19.4093 8.74773C19.5075 9.01197 19.651 9.28756 19.8322 9.49676L21.1896 11.0739V11.0749C21.5917 11.5451 21.6197 12.327 21.2638 12.8473L21.1876 12.9479L19.8322 14.5221C19.652 14.7301 19.5082 15.0028 19.4093 15.2673C19.3104 15.5319 19.2404 15.833 19.2404 16.11V17.8102C19.2402 18.594 18.5935 19.2399 17.8097 19.2399H16.1105C15.8379 19.2399 15.5368 19.3107 15.2726 19.4089C15.0087 19.5069 14.7327 19.6499 14.5236 19.8307L12.9435 21.1911C12.4427 21.6179 11.5903 21.6214 11.0753 21.1901L9.49622 19.8307C9.28841 19.6511 9.01607 19.5075 8.75208 19.4089C8.48765 19.3101 8.18707 19.24 7.91028 19.2399H6.17981C5.39612 19.2398 4.75025 18.5939 4.75012 17.8102V16.1003C4.75012 15.8272 4.67972 15.5282 4.58313 15.2673C4.48629 15.0057 4.34579 14.7362 4.17395 14.53L4.17102 14.5261L2.82043 12.9362C2.39923 12.4325 2.39887 11.5861 2.82043 11.0827L2.82141 11.0837L4.17102 9.49383L4.17395 9.48992C4.34581 9.28368 4.48629 9.0142 4.58313 8.75262C4.67972 8.49168 4.75012 8.19264 4.75012 7.91961V6.19988C4.75019 5.41614 5.39608 4.7703 6.17981 4.7702H7.91028C8.1829 4.77015 8.48392 4.69944 8.74817 4.60125C9.01142 4.50341 9.28539 4.35962 9.49426 4.17937L9.49524 4.18035L11.0743 2.82977H11.0753Z"
                        fill="#FFB400"
                        stroke="#212121"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        data-fill="true"
                    />
                    <path
                        d="M8.37891 12.0001L10.7889 14.4201L15.6189 9.58008"
                        stroke="#212121"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            ),
        }}
    />
);
